<apm-icon
  size="md"
  icon="a_download_document"
  [matTooltipPosition]="matTooltipPosition"
  [matTooltipClass]="matTooltipClass"
  [isButton]="true"
  [hasHoverIcon]="true"
  [disabled]="disabled || documentIsInProgress"
  (iconClick)="!documentIsInProgress && (documentIsComplete ? downloadDocument() : onCreateDocument($event))"
  matTooltip="{{ (documentIsComplete ? '445258' : '445259') | apmTranslate }}"
></apm-icon>
